import React from 'react';
import { useSelector } from 'react-redux';
import { OfflineIcon } from 'evergreen-ui';
import { datasourceStatusStormModeSelector } from 'Features/App/Dictionaries/dictionariesSlice';
import { timeZoneSelector } from 'Features/App/appSlice';
import { UTCtoTimeZone } from 'Utils/UTCConverter';
import StatusIcon from './StatusIcon';
import { DatasourceIdProps } from '../utils';
import { initialStatusData, StatusDataType } from './utils';

export function StormModeStatus({ datasourceId }:DatasourceIdProps) {
  const selectedZone = useSelector(timeZoneSelector);
  const status = useSelector(datasourceStatusStormModeSelector(datasourceId));

  const { text, intent, time }: StatusDataType = React.useMemo(() => {
    const { vocModeId, dateTimeUpdate } = status || {};

    switch (vocModeId) {
      case 1:
        return {
          time: UTCtoTimeZone(dateTimeUpdate, selectedZone.selectedUserTimeZone),
          text: 'Штатный режим',
          intent: 'success',
        };
      case 2:
        return {
          time: UTCtoTimeZone(dateTimeUpdate, selectedZone.selectedUserTimeZone),
          text: 'Штормовой режим',
          intent: 'danger',
        };
      default: return initialStatusData;
    }
  }, [selectedZone.selectedUserTimeZone, status]);

  return (
    <StatusIcon
      time={time}
      statusInfo={`Режим источника: ${text}`}
      intent={intent}
      icon={OfflineIcon}
    />
  );
}
export default StormModeStatus;
